module.exports = __webpack_public_path__ + "static/media/notif.c6378248.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/notif.mp3
// module id = 671
// module chunks = 0